import { useApiClient } from "@/infrastructure/rest/apiClient";
import { useMutation } from "@tanstack/react-query";

type PostDossierUpdateRequest = {
    dossierId: string;
    laatstGewijzigdVeld: string;
};
export function usePublishDossierUpdate() {
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ dossierId, laatstGewijzigdVeld }: PostDossierUpdateRequest) => {
            await apiClient.post(`/debug/dossiers/${dossierId}/publish-update?laatstGewijzigdVeld=${laatstGewijzigdVeld}`);
        },
        onError: (error) => {
            console.error("Fout bij het publiceren van dossier update", error);
        },
    });
}
